module.exports = __webpack_public_path__ + "img/head.f5c22b9d.gif";